import { CoreIcon } from '../core-icon';
import dashboardColorSVG from '../../assets/icons/dashboard-color.svg';
import type { IconProps } from '../core-icon';

export const DashboardColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={dashboardColorSVG} {...props} />;
};
